const formatNumber = (number, empty = '-') => {
  if (isNaN(number)) return null;
  return number !== null ? parseInt(number).toLocaleString(): empty;
};

export default formatNumber;
